import React, { useState, useEffect } from 'react';
import { getReleaseNoteApi } from '../../../../api/post';
import Spinner from 'react-bootstrap/Spinner';
import { errorModal, warningModal } from '../../../Alerts/Alerts';

export default function InfoReleaseNotes(props) {
    const { url } = props;
    const [ postInfo, setPostInfo ] = useState(null);

    useEffect(() => {
        getReleaseNoteApi(url)
        .then(response => {
            if (response.code !== 200) {
                warningModal("Advertencia", response.message);
            } else {
            setPostInfo(response.post);
            }
        })
        .catch(() => {
            errorModal	("Error", "Error del Servidor.");
        });
        
    }, [url]);

    if (!postInfo) {
        return (
            <Spinner animation="border" role="status" ></Spinner>
        );
    }

    return (
        <div className="containerImg">
            <span style={{"fontSize": "24px", "fontFamily": "tahoma"}}>{postInfo.nm_titulo}</span>
            <p dangerouslySetInnerHTML={{__html: postInfo.gl_contenido}}></p>
        </div>
    )
}
